import setBuilder from '../../../../../../Template/config/components/selection/SetBuilder'
import setBuilderToolbar from './setBuilderToolbar'


export default  {
    ...setBuilder,
    setBuilderToolbar
}